import posthog from "posthog-js";

let initialized = false;

export function usePostHog() {
  if (!initialized && import.meta.env.VITE_POSTHOG_KEY) {
    posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
      // Send events through our PostHog-managed reverse proxy
      // (https://t.audioscribe.io) so ad blockers don't drop them at
      // the network layer. ui_host points at the real PostHog UI so
      // links generated by the SDK (e.g. session replay URLs) resolve
      // correctly.
      api_host: import.meta.env.VITE_POSTHOG_HOST || "https://t.audioscribe.io",
      ui_host: "https://us.posthog.com",
      defaults: "2026-01-30",
      person_profiles: "identified_only",
      autocapture: false,
      capture_pageview: true,
      capture_pageleave: true,
      // Share the distinct_id via a `.audioscribe.io` cookie so the anonymous
      // identity from the marketing site (audioscribe.io free tools) carries
      // here to app.audioscribe.io. identify() at signup then stitches the
      // prior anonymous tool usage to the user — the basis for the anon→signup
      // canary funnel. localStorage alone is origin-scoped and breaks this.
      persistence: "localStorage+cookie",
      cross_subdomain_cookie: true,
      loaded: (ph) => {
        if (import.meta.env.DEV) ph.debug();
      },
    });
    initialized = true;
  }

  return { posthog };
}
